(ns lupapalvelu.ui2.toggle-group
  (:require [reagent.core :as r :refer [defc]]))

;; TODO: Take props for option elements from top-level props (:option-props)
;; or :props under option items?
;; TODO: size option? now only "sm"?
;; TODO: Add :multiple option
;; TODO: Recommend aria-label for the props?
;; TODO: Add disabled option?
(defc toggle-group
  "Options:
    :value       - current value, matching one of option :value
    :class       - extra container el classes
    :on-change   - (fn [option e] ...)
    :options     - collection of {:key ... :value ... :title ...}"
  [{:keys [value options on-change class] :as props}]
  [:div
   (r/merge-props {:class ["border-primary" "border-1" "rounded-sm"
                           "flex flex-row flex-wrap gap-y-[1px] bg-white"
                           class]
                   :role  "group"}
                  (dissoc props :class :options :value :on-change :option-props))
   (for [{:keys [title]
          :as   option} options
         :let           [active (= value (:value option))]]
     [:button
      {:key          (:key option)
       :type         "button"
       :class        ["border-primary border-1"
                      "hover:bg-primary hover:text-white"
                      "px-2 py-1 m-[-1px]"
                      "first:rounded-l-sm last:rounded-r-sm"
                      "text-xs"
                      (if active
                        "bg-primary text-white"
                        "bg-white")]
       :aria-pressed active
       :on-click     (fn [e]
                       (.stopPropagation e)
                       (on-change option e))}
      title])])
